import { useConfig } from "../../hooks/useConfig";
import { txUrl } from "../../wallets/chain";

/**
 * The donation ledger, read from the server (data/donations.json). One row per
 * donation. Quarterly rows carry the two transactions behind them so the pledge
 * can be checked on chain; a gift paid from the team's own pocket has none.
 */
const COLUMNS = ["Entry", "Source", "Fees claimed (tx)", "Sold (tx)", "CAD donated", "Date", "Reference"];

export const formatCad = (value: number): string =>
  `CA$${new Intl.NumberFormat("en-CA", { maximumFractionDigits: 0 }).format(value)}`;

const txCell = (hash: string | null, explorerUrl: string) =>
  hash === null ? (
    <span className="table__muted">none, paid from pocket</span>
  ) : (
    <a className="mono" href={txUrl(explorerUrl, hash)} target="_blank" rel="noreferrer noopener">
      {hash.slice(0, 10)}...
    </a>
  );

export function Ledger({ explorerUrl }: { explorerUrl: string }) {
  const { config } = useConfig();
  const entries = config?.donations?.entries ?? [];
  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            {COLUMNS.map((column) => (
              <th key={column} scope="col">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {entries.length === 0 ? (
            <tr>
              <td className="table__empty" colSpan={COLUMNS.length}>
                No donation has been made yet.
              </td>
            </tr>
          ) : (
            entries.map((entry) => (
              <tr key={entry.id}>
                <td>{entry.label}</td>
                <td className="table__wrap">{entry.source}</td>
                <td>{txCell(entry.feesClaimedTx, explorerUrl)}</td>
                <td>{txCell(entry.soldTx, explorerUrl)}</td>
                <td>{formatCad(entry.cad)}</td>
                <td>{entry.date}</td>
                <td className="table__wrap">
                  {entry.reference ?? "none"}
                  {entry.acknowledgement ? ` Acknowledged: ${entry.acknowledgement}` : ""}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
